// const CONSTANTS = {
//   LOADING: "loading",
//   FETCHING: "fetching",
//   WARNING: "warning",
//   RANDOM: "random",
//   STORED: "stored",
//   DATA: "DATA",
//   LOCAL: "VOICE-LCL",
//   INTERNATIONAL: "VOICE-INT",
//   ANGHAMI_KEY: "AnghamiPromotion",
//   ANGHAMI_TEXTCODE: "%ANGHAMI%",
//   FAMILY_PLAN_TEXTCODE: "%FAMILY_PLAN%",
//   DATA_ROLLOVER_TEXTCODE:"%DATA_ROLLOVER_TEXTCODE%",
//   
//   
//   
// };

const BB_PRODUCT_CODE = [190,194];
const NON_RESIDENT = "non_resident";
const RESIDENT = "resident";
const BB_SERVICE_TYPES = "3,16";
const NON_SET = null;

const FAMILY_PLAN_TEXTCODE = "%FAMILY_PLAN%";
const LOADING = "loading";

const MIN_CHARS_AUTOCOMPLETE = 3;
const MONEY_BACK_GUARENTEE_REFUND_FAQ_LINK_TEXTCODE = "%REFUND_FAQ%";

export { MONEY_BACK_GUARENTEE_REFUND_FAQ_LINK_TEXTCODE, MIN_CHARS_AUTOCOMPLETE, RESIDENT, NON_RESIDENT, NON_SET, LOADING, BB_PRODUCT_CODE, BB_SERVICE_TYPES, FAMILY_PLAN_TEXTCODE }
